import { useTranslation } from 'react-i18next'

/**
 * Thin status band shown at the top of the routes when the viewport
 * is narrower than 768px (PRD #74). Tells the user the app is read-
 * only on this device — interactive review needs a desktop browser.
 *
 * Mono small caps to fit the editorial × terminal tone; uses the
 * standard --color-warn / --color-border tokens so the band reads
 * as instrumentation, not a panic alert.
 */
export function MobileNotice() {
  const { t } = useTranslation()
  return (
    <div role="status" className="markfy-mobile-notice">
      {t('mobile.notice')}
    </div>
  )
}
